import { useEffect, useRef, useState } from 'react';
import { useSelector,useDispatch } from "react-redux";
import UserSignDoc from './helper/UserSignDoc';
import { Group, Grid, Tooltip, ScrollArea, Modal, Button, Text, Alert, createStyles, rem, ActionIcon }  from '@mantine/core';
import { FileText, PencilPlus, FileCheck, FileSpreadsheet, Eye, CircleX, EyeCheck   } from 'tabler-icons-react';
import { DocSignCountbyUser } from './helper/DocSignCountbyUser';
import DocReadAllCloseButton from './helper/DocReadCloseButton';
import DocReadAllButton from './helper/DocReadAllButton';
import PdfLabel from './helper/PdfLabel';
import { set_Acc_InProgress, set_docstoconvert,read_doc_notaronly, clear_read_doc_notaronly } from '../slice/mainslice';
import intl from 'react-intl-universal';

import { SignDocumentStatus } from './helper/SignDocumentStatus';
import { DocumentStatusHasSignatures } from './helper/DocumentStatusHasSignatures';


const useStyles = createStyles((theme) => ({
  showuserback: {
    backgroundColor: `#ffffff`,
    marginBottom: `10px`,
    padding: `5px`,
  },
  textsize: {
          fontSize: rem('12px'),
          [theme.fn.smallerThan('lg')]: {
            fontSize: rem('10px'),
          },
  },
    nogap: {
      padding: 0,
    },
  nogaptop: {
      padding: 0,
      marginTop: `-10px`,
    },
}));



const SignatureDoc = (props:any) => {
  const dispatch = useDispatch()
   const { classes } = useStyles();
  const initdocs = useSelector((state: any) => state.user.meetingdocs)
  const drnId = useSelector((state: any) => state.user.meetinginfo.drnId)
  const userhavetosigndocs = useSelector((state: any) => state.user.userhavetosigndocs)
  const [docinprogress, setDocinprogress] = useState({view: false, resourceId: "" });
  const [showscrollbar, setshowscrollbar] = useState(false);
  const [opened, setOpened] = useState(false);
  const [docconvert, setDocconvert] = useState("");

  const iniusersigndocs = useSelector((state: any) => state.user.userhavetosigndocs)
  const notarreaddoconly = useSelector((state: any) => state.user.readdocnotaronly)
  const inituser = useSelector((state: any) => state.user.meetinguser)
  

   const [contrefsigheight, setcontrefsigheight] = useState(0);
   const contrefsig = useRef<HTMLDivElement>(null);


  useEffect(() => {

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === contrefsig.current) {
          const { height } = entry.contentRect;
          setcontrefsigheight(height);
         // console.log('Height changed:', height, 'px');
        }
      }
    });

    if (contrefsig.current) {
      observer.observe(contrefsig.current);
    }

    return () => {
      if (contrefsig.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(contrefsig.current);
      }};
    }, []);



 useEffect(() => {
  if (contrefsigheight > 420 ) {
    setshowscrollbar(true)
  }

}, [contrefsigheight]);


/**
 * Updates the state of `docconvert` with the provided `resourceId` and sets `opened` to `true`.
 * Modal Handling
 *
 * @param {boolean} view - A boolean indicating whether the view is being shown or not.
 * @param {string} resourceId - The ID of the resource to be converted.
 * @return {void} This function does not return anything.
 */
const handleconvertDocinprogress = (view:boolean, resourceId:string) => {
  setDocconvert(resourceId);
  setOpened(true);
}


const handleClose = () => {
  setOpened(false);
};


const handleYesClick = () => {
  console.log("handleYesClick docconvert:",docconvert)
  handlesetDocinprogress(true, docconvert)
  setDocconvert("");
  sendopendocforsign_shared(true, docconvert)
  handleClose();
};

const handleNoClick = () => {
  setDocconvert("");
  handleClose();
};

  /**
   * Handles the click event for the convert button.
   * Calls the `convertsinglepdf` function to convert a single PDF.
   * Updates the `docinprogress` state with the provided `view` and `resourceId` values.
   * Closes the modal.
   *
   * @return {void} This function does not return anything.
   */
const handleConvertClick = () => {
  convertsinglepdf();
  sendopendocforsign_shared(true, docconvert)
  handleClose();
}

/**
 * Converts a single PDF document.
 *
 * @return {void} This function does not return anything.
 */
const convertsinglepdf = () => {
   
  const storeArray = [{
    resourceId: docconvert,
    error: null
  }];


  const convertarray = {
    drnId: drnId,
    DocumentResourceIds: [docconvert],
    IsForced: true
  };

   dispatch(set_docstoconvert(storeArray))
   dispatch({ type: 'SIGNALR_REQUEST_CONVERTDOKS', payload: convertarray });

}


/**
 * Setzt den Status "alle User haben das Dokument unterschrieben""
 *
 * @param {any} drnId - DRN Meeting ID
 * @param {any} resourceId - Dokumenten ID
 * @param {boolean} isSignedByAll - Status
 */
  const docisfinished = (resourceId:any) => {
    // Sent have Read Sign
    const handledocisfinished  = {
      drnId: drnId,
      resourceId: resourceId,
      isSignedByAll: true   
  };

  dispatch({ type: 'SIGNALR_SETDOCUMENTISSIGNEDBYAll', payload: handledocisfinished  });
}

/**
 * Nimmt den Status "alle User haben das Dokument unterschrieben" zurück"
 *
 * @param {any} drnId - DRN Meeting ID
 * @param {any} resourceId - Dokumenten ID
 * @param {boolean} isSignedByAll - Status
 */
const docisnotfinished = (resourceId:any) => {
  // Sent have Read Sign
  const handledocisfinished  = {
    drnId: drnId,
    resourceId: resourceId,
    isSignedByAll: false   
};

dispatch({ type: 'SIGNALR_SETDOCUMENTISSIGNEDBYAll', payload: handledocisfinished  });
}

  /**
   * A function that handles setting the document in progress.
   *
   * @param {boolean} view - Ansichtsparameter
   * @param {string} resourceId - Dokumente ID
   * @return {void} 
   */
  const handlesetDocinprogress = (view:boolean, resourceId:string ) => {
    setDocinprogress({ ...docinprogress, view: view, resourceId: resourceId })
    setshowscrollbar(false)
  }


  /** Neu Funktion um den Unterschrift Protess direkt auszulösen DEMO Only*/

  const sendopendocforsign_shared = (view:boolean, resourceId:string) => { 

      // Filtern des Arrays
      const gefilterteDokumente =  userhavetosigndocs.filter(
      (dokument: { resourceId: string; }) => dokument.resourceId === resourceId
      );

      //console.log("gefilterteDokumente:",gefilterteDokumente[0].user);
    
      const sendopendocforsign_sharedpayload = {
      resourceId: resourceId,
      drnId: drnId,
      command: "opendoc",
      participantIdsToSign: gefilterteDokumente[0].user,   
    };

   // console.log("sendopendocforsign_sharedpayload:",sendopendocforsign_sharedpayload );

    dispatch({ type: 'SIGNALR_SENDOPENDOCFORSIGNSHARED', payload: sendopendocforsign_sharedpayload });
    dispatch(set_Acc_InProgress("Unterschriften"))
  }


  const openreaddoc = (resourceId:string) => {
    // Set Read Doc Notar Only State
    dispatch(read_doc_notaronly(resourceId));
  }

  const closereaddoc = () => {
    // Clear Read Doc Notar Only State
    dispatch(clear_read_doc_notaronly());
  }





  let initdocsdata
  initdocsdata = initdocs.filter((obj: { isToBeSigned: boolean; }) => {
    return obj.isToBeSigned === true
  });






//console.log(iniusersigndocs)
// eslint-disable-next-line array-callback-return
const rows = (initdocsdata  || []).map((item:any, index:any) => {

  // Check if there are User to sign document
  // if 0 dont display it
  const datatosign = iniusersigndocs?.filter((obj: { resourceId: any }) => obj.resourceId === item.resourceId) || [];

  //console.log("item:",item.signatures);
 
  // Auslesen wieviele User das Dokument schon unterschrieben haben
  let hassign = 0;
  if (item.signatures && item.signatures.length > 0){
    hassign = item.signatures.length;
  }
  

  
  let color
  if (item.isSignedByAll === true) {
    color = "green"
  } else {
    color = "gray"
  }


  if (docinprogress.view === false && datatosign.length > 0){
    return (
<div key={item.resourceId} className={classes.showuserback}>
  <Grid key={item.resourceId}>  
    <Grid.Col span={12} className={classes.nogap}>
             <Group  spacing={1}  position="right">
              {hassign >=1 && notarreaddoconly === "" &&
                    <ActionIcon
                      //disabled={isDisabledShow}
                      size="xl"
                      variant="transparent"
                      onClick={() => openreaddoc(item.resourceId)}
                              >
                      <EyeCheck size={26} strokeWidth={1} />
                    </ActionIcon>
        
              }
              {hassign >=1 && notarreaddoconly !== "" &&
              <ActionIcon
                      //disabled={isDisabledShow}
                      size="xl"
                      variant="transparent"
                      onClick={() => closereaddoc()}
                              >
                      <CircleX size={26} strokeWidth={1} />
                    </ActionIcon>
              }

             <Tooltip label={intl.get('SIGDOC_TT_USERSIGN')} multiline={true}>
                  <span>
             {item.isPDFA1b &&  
                <ActionIcon
                      //disabled={isDisabledShow}
                      size="xl"
                      variant="transparent"
                       onClick={() => sendopendocforsign_shared(true, item.resourceId)}
                              >
                      <PencilPlus size={26} strokeWidth={1} />
                </ActionIcon>  
              } 
            {!item.isPDFA1b &&  
               <ActionIcon
                      //disabled={isDisabledShow}
                      size="xl"
                      variant="transparent"
                       onClick={() => handleconvertDocinprogress(true, item.resourceId)}
                              >
                      <PencilPlus size={26} strokeWidth={1} />
                </ActionIcon>    
             
              }  

              </span>
            </Tooltip>
            </Group>
   </Grid.Col>
   </Grid> 
    
    
    
    
    <Grid key={index}>
       <Grid.Col span={2} className={classes.nogaptop}>  
        <SignDocumentStatus resourceId={item.resourceId} />
      {/*       
       {item.isSignedByAll &&
        <FileCheck size={48} strokeWidth={1} color={color} />
       }
      {!item.isSigPrepared && !item.isSignedByAll &&
        <FileText size={48} strokeWidth={1} color={color} />
      }
      {item.isSigPrepared && !item.isSignedByAll &&
        <FileSpreadsheet size={48} strokeWidth={1} color="gray" /> 
      }
        */}

   
       
      </Grid.Col>
   <Grid.Col span={10}> 
   <PdfLabel isPDFA1b={item.isPDFA1b} signatureCount={item.signatureCount} resourceId={item.resourceId} convert={true} viewcount={false}/>
      
      
        <div className={classes.textsize}> {item.name}</div>
         <DocSignCountbyUser resourceId={item.resourceId}  />
          
         
   </Grid.Col>
          
 </Grid>
    <hr />
      </div>
   );
  };



  

  });


  return (
    <>
    
    {!showscrollbar &&
      <>
      <div ref={contrefsig}>
        {rows}
      </div>
      </>
      }
      {showscrollbar &&
      <>
      <ScrollArea h={420} type="hover" offsetScrollbars>
        {rows}
      </ScrollArea>
      </>
      }

<Modal
title=""
opened={opened}
onClose={handleClose}
closeOnClickOutside={false}
withCloseButton={false}
size="55%"
shadow="sm"
centered
>
  <Text>{intl.get('SIGDOC_MOD_KONVERTTEXT')}</Text>

  <hr />
  <Grid>
  <Grid.Col span={4}>
    <Button fullWidth color="green" onClick={handleYesClick}>{intl.get('SIGDOC_MOD_BUTYES')}</Button>
    </Grid.Col>
    <Grid.Col span={4}>
       <Button fullWidth color="teal" onClick={handleConvertClick}>{intl.get('SIGDOC_MOD_BUTKONV')}</Button>
    </Grid.Col>
    <Grid.Col span={4}>
    <Button fullWidth color="gray" variant="light" onClick={handleNoClick}>{intl.get('SIGDOC_MOD_BUTNO')}</Button>
    </Grid.Col>
  </Grid>
</Modal> 
     
   </>

   

    

  );
}

export default SignatureDoc;